import { AppDefinition, AppIcon } from '../../types/apps';
import { GENERIC_ENTITY_TYPES } from '../TemplateEntityKit/registry/templateEntityTypes.m';

/**
 * Per-type entity icons for iconService (which matches an entity to its owning
 * app via `entityTypes` then reads `entityIcons[type]`). Adding a new generic
 * template-entity type = add its entityType to GENERIC_ENTITY_TYPES + one line
 * here (the only static per-type touch this app needs). The same icon lives in
 * the type's TemplateEntitySchema for the "New" menu / tool cards.
 */
const ENTITY_ICONS: Record<string, AppIcon> = {
  Character: { type: 'phosphor', phosphorIcon: 'User', phosphorWeight: 'duotone', color: '#8b5cf6' },
  Equipment: { type: 'phosphor', phosphorIcon: 'Wrench', phosphorWeight: 'duotone', color: '#f59e0b' },
};

const searchableSkeletonFields: Record<string, string[]> = Object.fromEntries(
  GENERIC_ENTITY_TYPES.map((t) => [t, ['displayName', 'compiledPrompt']]),
);

export const SchemaEntityAppDefinition: AppDefinition = {
  appId: 'schema-entity',
  name: 'Card',
  version: '0.1.0',
  description:
    'Renders every schema-driven, reusable/forkable, AI-image-bearing "card" entity built on the Generic Template Entity Kit (Character, Equipment, and future types). One app for all — adding a type needs only a schema.',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Cards',
    phosphorWeight: 'duotone',
    color: '#8b5cf6',
    metadata: { source: 'app', appId: 'schema-entity', isAppIcon: true },
  },
  entityIcons: ENTITY_ICONS,
  entityTypes: [...GENERIC_ENTITY_TYPES],
  searchableSkeletonFields,
  component: 'SchemaEntityApp',
  requiresProps: false,
  requiresEntity: true,
  agenticToolIds: [
    'template_entity_create',
    'template_entity_read',
    'template_entity_update',
  ],
  actions: {},
};

export default SchemaEntityAppDefinition;
